import { Typography } from "@mui/material";
import Swal from "sweetalert2";

export const showMensage = async (translate: any, sucess: any, error: any) => {
  if (error) {
    await Swal.fire(
      translate("screenApp_resetFirmwareComponents_titleErro"),
      error ? error : translate("labels_errorEmail"),
      "error",
    );
  } else if (sucess) {
    await Swal.fire({
      title: translate("defaultMessages_success"),
      text: translate(sucess),
      // text: translate("labels.emailSuccess"),
      icon: "success",
      showCancelButton: false,
      confirmButtonText: translate("buttons.ok"),
      cancelButtonText: translate("buttons.exit"),
    });
  }
};

export const helperText = (text: string) => (
  <Typography color={"red"}>{text}</Typography>
);
